import {NgModule, inject} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ResultsComponent} from "../components/results/results.component";
import { MsalRedirectComponent } from '@azure/msal-angular';
import { AiSearchComponent } from '../components/ai-search/ai-search.component';
import { AuthGuard } from '../guards/auth.guard';
import { IdResolverComponent } from '../components/id-resolver/id-resolver.component';

const routes: Routes = [
  {
    path: 'auth',
    component: MsalRedirectComponent
  },
  {
    path: 'ai',
    component: AiSearchComponent,
    canActivate: [AuthGuard],
    data: { animation: 'ai' },
  },
  {
    path: 'id/:uniqueId',
    component: IdResolverComponent,
  },
  {
    path: '',
    component: ResultsComponent,
    pathMatch: 'full',
    data: { animation: 'first' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)], 
  exports: [RouterModule]
})
export class AppRoutingModule {
}
